import request from '@/utils/request'

// 首页
// 我的消息
export function hallWdxx() {
    return request({
        method: 'get',
        url: "/yzdservice/api/notice/all"
    })
}


// 信息互动
// 通知公告  表格数据
export function hallTzgg(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/notice/page",
        data: data
    })
}

// 通知公告  表格数据
export function hallckmb(noticeId) {
    return request({
        method: 'GET',
        url: "/yzdservice/api/notice/info/" + noticeId
    })
}

// 首页点击
// 法律法规  表格数据
export function hSYflfg(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/flfg/no_login/flfg/page",
        data: data
    })
}
// 政策文件  表格数据
export function hSYzcwj(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/flfg/no_login/zcwj/page",
        data: data
    })
}
// 获取客服热线
export function getKfdh() {
  return request({
    method: 'GET',
    url: "/yzdservice/api/kfdh/getOne"
  })
}
// 获取客服热线
export function getKfdhList() {
  return request({
    method: 'GET',
    url: "/yzdservice/api/kfdh/getList"
  })
}

// tab切换 获取法律法规
export function APIflfgAll() {
    return request({
        method: 'GET',
        url: "/yzdservice/api/flfg/no_login/flfg"
    })
}
//  tab切换 获取政策文件
export function APIzcwjAll() {
    return request({
        method: 'GET',
        url: "/yzdservice/api/flfg/no_login/zcwj"
    })
}

// 获取详情 法律法规 / 政策文件
export function APIhuoquxiangqing(id) {

    return request({
        method: 'GET',
        url: "/yzdservice/api/flfg/info/" + id
    })
}


// 获取  首页 新闻中心 数据
export function APIxwzxSY() {
    return request({
        method: 'GET',
        url: "/yzdservice/api/news/list"
    })
}

// 获取  新闻中心详情列表页数据
export function APIxwzxXQlb(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/news/all",
        data: data
    })
}


// 获取详情 法律法规 / 政策文件
export function APIhuoquxiangqingSY(id) {
    return request({
        method: 'GET',
        url: "/yzdservice/api/flfg/no_login/info/" + id
    })
}


// ================== 增益入库 ============
// 获取搜索 状态下拉
export function APIzhuangtai() {
    return request({
        method: 'GET',
        url: "/yzdservice/api/enum/rk/crksp"
    })
}

// 获取搜索 仓库下拉
export function APIcangku(ckId) {
  if(ckId){
    return request({
      method: 'GET',
      url: "/yzdservice/enterprise/dwCk/getCkxxByCskc/"+ckId
    })
  }else{
    return request({
      method: 'GET',
      url: "/yzdservice/enterprise/dwCk/getCkxxByCskc"
    })
  }
}


// 获取化学品下拉级联
export function APIhuaxuepinJL() {
    return request({
        method: 'GET',
        url: "/yzdservice/api/enterprise/credentials/common/getHxpCascader"
    })
}
// 获取经办人下拉
export function APIjingbanren() {
    return request({
        method: 'GET',
        url: "/yzdservice/enterprise/dwCk/syck/getLyrList"
    })
}



// 获取增溢列表
export function APIzylist(data) {
    return request({
        method: 'post',
        url: "/yzdservice/enterprise/dwCk/zyrk/list",
        data: data
    })
}

// 新增/ 编辑保存 增益入库(暂时保存)
export function APIzyrkTijiaoxinxiTemp(data) {
    return request({
        method: 'post',
        url: "/yzdservice/enterprise/dwCk/zyrk/addOrUpdSaveTemp",
        data: data
    })
}

// 新增/ 编辑保存 增益入库(入库)
export function APIzyrkTijiaoxinxi(data) {
    return request({
        method: 'post',
        url: "/yzdservice/enterprise/dwCk/zyrk/addOrUpdSave",
        data: data
    })
}

// 变更校验
export function APIbgjy(data) {
    return request({
        method: 'post',
        url: "/yzdservice/enterprise/dwCk/zyrk/changePdkcByZyrk",
        data: data
    })
}
// 信息变更
export function APIxxbg(data) {
    return request({
        method: 'post',
        url: "/yzdservice/enterprise/dwCk/zyrk/saveChangeApply",
        data: data
    })
}

// 增益入库导出
export function APIdaochu(data) {
    return request({
        method: 'post',
        url: "/yzdservice/enterprise/dwCk/zyrk/excelwriter",
        data: data,
        responseType: 'blob',
    })
}


// 增益数据详情数据
export function APIzyxiangqing(id) {
    return request({
        method: 'GET',
        url: "/yzdservice/enterprise/dwCk/zyrk/detail/" + id
    })
}
// 删除增益数据列表
export function APIzydelete(id) {
    return request({
        method: 'delete',
        url: "/yzdservice/enterprise/dwCk/zyrk/remove/" + id
    })
}



// =====================  购买入库 ============

// 状态下拉
export function APIGMzhuangtai() {
    return request({
        method: 'GET',
        url: "/yzdservice/api/enum/rk/ty"
    })
}

// 购买许可证 弹框数据
export function APIgmrkxkzlist(data, type = '0') {
    return request({
        method: 'post',
        url: `/yzdservice/enterprise/dwCk/gmrk/selectGmzList/${type}`,
        data: data
    })
}
// 购买许可证 弹框数据
export function APIgmrkxszlist(data) {
    return request({
        method: 'post',
        url: "/yzdservice/enterprise/dwCk/gmrk/selectYszList",
        data: data
    })
}

// 购买许可证确定
export function APIgjgmzzjcxgmzdxx(type, id,bgdisable) {
  if(bgdisable){
    return request({
      method: 'GET',
      url: `/yzdservice/enterprise/dwCk/gmrk/selectGmzxxById/${type}/${id}/bg`
    })
  }else{
    return request({
      method: 'GET',
      url: `/yzdservice/enterprise/dwCk/gmrk/selectGmzxxById/${type}/${id}`
    })
  }
}

// 购买入库 新增 / 编辑(暂时保存)
export function APIgmrkXzZcTemp(data) {
  return request({
    method: 'post',
    url: "/yzdservice/enterprise/dwCk/gmrk/addOrUpdSaveTemp",
    data: data
  })
}

// 购买入库 新增 / 编辑(入库)
export function APIgmrkXzZc(data) {
    return request({
        method: 'post',
        url: "/yzdservice/enterprise/dwCk/gmrk/addOrUpdSave",
        data: data
    })
}

// 购买入库列表
export function APIgmrkList(data) {
    return request({
        method: 'post',
        url: "/yzdservice/enterprise/dwCk/gmrk/list",
        data: data
    })
}
// 校验变更
export function APIjiaoyanBG(data) {
    return request({
        method: 'post',
        url: "/yzdservice/enterprise/dwCk/gmrk/changePdkcByGmrk",
        data: data
    })
}
// 提交变更
export function APItijiaoBG(data) {
    return request({
        method: 'post',
        url: "/yzdservice/enterprise/dwCk/gmrk/saveChangeApply",
        data: data
    })
}
// 购买入库导出
export function APIgmaidaochu(data) {
    return request({
        method: 'post',
        url: "/yzdservice/enterprise/dwCk/gmrk/excelwriter",
        data: data,
        responseType: 'blob',
    })
}

// 购买入库详情
export function APIgmrkXiangqing(id) {
    return request({
        method: 'get',
        url: "/yzdservice/enterprise/dwCk/gmrk/detail/" + id
    })
}

// 删除购买入库列表
export function APIgmrkdelete(id) {
    return request({
        method: 'delete',
        url: "/yzdservice/enterprise/dwCk/gmrk/remove/" + id
    })
}


// ====================运输报备 =====================

// 获取运输报备弹框内容
export function APIysbbtableData(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/transport/crklist",
        data: data
    })
}

// 获取运输报备 详情
export function APIhqyszXq(id) {
    return request({
        method: 'GET',
        url: "/yzdservice/api/enterprise/ysbb/hqzsxx/" + id
    })
}

// 运输报备 新增暂时保存
export function APIysbbXzZcTemp(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/ysbb/addTemp",
        data: data
    })
}

// 运输报备 新增报备保存
export function APIysbbXzZc(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/ysbb/add",
        data: data
    })
}

// 运输报备  编辑暂时保存
export function APIysbbXzZc1Temp(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/ysbb/editTemp",
        data: data
    })
}
// 运输报备  编辑报备保存
export function APIysbbXzZc1(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/ysbb/edit",
        data: data
    })
}

// 运输报备获取列表
export function APIysbbHqlb(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/ysbb/list",
        data: data
    })
}

// 状态下拉
export function APIBBzhuangtai() {
    return request({
        method: 'GET',
        url: "/yzdservice/api/enum/bb/ty"
    })
}
// 状态下拉
export function APIysbbXiangqign(id) {
    return request({
        method: 'GET',
        url: "/yzdservice/api/enterprise/ysbb/detail/" + id
    })
}


// 删除运输报备
export function APIshanchuysbb(id) {
    return request({
        method: 'delete',
        url: "/yzdservice/api/enterprise/ysbb/delete/" + id
    })
}

// 运输报备变更
export function APIysbbbiangeng(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/ysbb/saveChangeApply",
        data: data
    })
}

// 运输报备导出
export function APIysbbdaochu(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/ysbb/excelwriter",
        data: data,
        responseType: 'blob',
    })
}


// ====================   移库报备    =====================

// 移出仓库下拉
export function APIykbbycckXl(id,ckId) {
  if(ckId){
    return request({
      method: 'get',
      url: "/yzdservice/enterprise/dwCk/getCkxxAndKcxx/" + id+"/"+ckId
    })
  }else{
    return request({
      method: 'get',
      url: "/yzdservice/enterprise/dwCk/getCkxxAndKcxx/" + id
    })
  }

}

// 移入仓库下拉
export function APIykbbyrckXl(ckId) {
  if(ckId){
    return request({
      method: 'get',
      url: "/yzdservice/enterprise/dwCk/getCkxxByCskc/"+ckId
    })
  }else{
    return request({
      method: 'get',
      url: "/yzdservice/enterprise/dwCk/getCkxxByCskc"
    })
  }
}
// 经办人下拉
export function APIysbbjbrXl() {
    return request({
        method: 'get',
        url: "/yzdservice/enterprise/dwCk/syck/getLyrList"
    })
}

// 移库报备新增（暂时保存）
export function APIysbbzanshibcTemp(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/ykbb/addTemp",
        data: data
    })
}
// 移库报备新增（报备保存）
export function APIysbbzanshibc(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/ykbb/add",
        data: data
    })
}

// 获取移库报备列表
export function APIysbbliebiaoall(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/ykbb/list",
        data: data
    })
}

// 状态下拉
export function APIykbbzhuangtai() {
    return request({
        method: 'GET',
        url: "/yzdservice/api/enum/bb/ty"
    })
}


// 删除移库报备
export function APIshanchuykbb(id) {
    return request({
        method: 'delete',
        url: "/yzdservice/api/enterprise/ykbb/delete/" + id
    })
}


// 移库报备导出
export function APIykbbdaochu(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/ykbb/excelwriter",
        data: data,
        responseType: 'blob',
    })
}


// 获取移库报备详情
export function APIykbbxaingqing(id) {
    return request({
        method: 'GET',
        url: "/yzdservice/api/enterprise/ykbb/detail/" + id
    })
}
// 移库报备编辑（暂时保存）
export function APIzancunbianjiTemp(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/ykbb/editTemp",
        data: data
    })
}
// 移库报备编辑（移库保存）
export function APIzancunbianji(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/ykbb/edit",
        data: data
    })
}
// 获取移库报备  变更校验
export function APIykbbbgjiaoyan(data) {
    return request({
        method: 'POST',
        url: "/yzdservice/api/enterprise/ykbb/change",
        data: data
    })
}

// 获取移库报备  变更提交
export function APIykbbbgtijiao(data) {
    return request({
        method: 'POST',
        url: "/yzdservice/api/enterprise/ykbb/saveChangeApply",
        data: data
    })
}


// 获取移库报备 化学品默认下拉
export function APIykbbhuoqumorenhxp() {
    return request({
        method: 'GET',
        url: "/yzdservice/api/enterprise/credentials/common/getHxpCascader"
    })
}
